import { gql } from '@apollo/client';
import { CartInfoPublic } from '../fragments';

export default gql`
  mutation calculateCartTax($input: CartTaxCalculateInput!) {
    calculateCartTax(input: $input) {
      capability {
        enabled
        reason
      }
      taxQuoteId
      expiresAt
      cart {
        ...CartInfoPublic
      }
      errorMessages {
        code
        message
        path
      }
    }
  }
  ${CartInfoPublic}
`;
